export default __webpack_public_path__ + "static/media/tokennomics.1269a2c1.png";